import React from 'react';

const CustomCheckbox = ({
    label,
    checked = false,
    onChange,
    name,
    disabled = false,
}) => {
    return (
        <div >
            <label style={{ ...styles.label, cursor: disabled ? 'not-allowed' : 'pointer' }}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    name={name}
                    disabled={disabled}
                    style={styles.hiddenCheckbox}
                />
                <span style={{
                    ...styles.customCheckbox,
                    backgroundColor: checked ? '#1976d2' : '#fff',
                    borderColor: checked ? '#1976d2' : '#ccc',
                }}>
                    {checked && (
                        <svg
                            viewBox="0 0 24 24"
                            width="16"
                            height="16"
                            fill="none"
                            stroke="#fff"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                    )}
                </span>
                <span style={{ ...styles.text, color: disabled ? '#aaa' : '#333' }}>
                    {label}
                </span>
            </label>
        </div>
    );
};

const styles = {
    label: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        userSelect: 'none',
        width: 'fit-content',
    },
    hiddenCheckbox: {
        display: 'none',
    },
    customCheckbox: {
        width: '18px',
        height: '18px',
        border: '2px solid #ccc',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease-in-out',
    },
    text: {
        fontSize: '16px',
    },
};

export default CustomCheckbox;
